import React, { Component } from 'react';
import './App.css';
import HomePage from './pages/homepage/homepage.pages';
import { Switch, Route } from 'react-router-dom';
import ShopPage from './pages/shop/shop.pages';
import Header from './components/header/header.component';
import CheckoutPage from './pages/check-out/check-out.component';

const ErrorPage = () => {

  return (
    <div style={{textAlign: 'center'}} >
      <h1 style={{fontSize: '25px'}} >Wrong URL</h1>
    </div>
  )
}


class App extends Component { 
  render() {
    return (
      <div className="App">
        <Header/> 
        <Switch>
          <Route exact path='/' component={HomePage}/>
          <Route path='/shop' component={ShopPage}/>
          <Route exact path='/checkout' component={CheckoutPage}/>
          <Route path='*' component={ErrorPage} />
        </Switch>
      </div>
    )
  }
}


export default App;
